/* eslint-disable no-restricted-syntax */
export const REGEX_COMPANY_INVALID_CHARACTERS = /[`~!@#$%^*(){}\[\]|\\/":<>?.№;_+=]+/gi
export const REGEX_TRIM_ALL_SPACES = /^\s+|\s+$/gm
export const REGEX_TAX_INVALID_CHARACTERS = /[`~!@#$%^*(){}\[\]|\\"<>?;+=]+/gi
